import { IPlayerProps } from "@lottiefiles/react-lottie-player"
import dynamic from "next/dynamic"
import React, { FC } from "react"

import * as files from "./files"

export type FileName = keyof typeof files

// Create a client-side only version of the Player component
const Player = dynamic(() => import("@lottiefiles/react-lottie-player").then((mod) => mod.Player), {
  ssr: false,
})

export interface LottieAnimationProps {
  name: FileName
  className?: string
  autoplay?: IPlayerProps["autoplay"]
  loop?: IPlayerProps["loop"]
}

export const LottieAnimation: FC<LottieAnimationProps> = ({
  name,
  autoplay = !process.env.STORYBOOK,
  loop = true,
  className,
}) => {
  const src = files[name]
  return <Player className={className} autoplay={autoplay} loop={loop} src={src} />
}

export const Spinner: FC<Omit<LottieAnimationProps, "name">> = (props) => <LottieAnimation name="spinner" {...props} />

export default LottieAnimation
